<div id="snapshotPdf" class="flex flex-col gap-2 f-s-12" style="max-width: 1000px; width: 100%; font-size: 12px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; zoom: reset; -webkit-text-size-adjust: 100%; -moz-text-size-adjust: 100%; text-size-adjust: 100%;">
  <mat-card>
    <mat-card-title>
      <div><span class="strong">License type: </span>&nbsp;&nbsp;&nbsp;&nbsp;Worker Permit</div>
      <div><span class="strong">Permit #: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{license.licenseId}}</div>
      <div><span class="strong">Date of application submission: </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{license.applicationDate}}</div>
      <div><span class="strong">Renewal number: </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{license.renewalCount}}
      </div>
    </mat-card-title>
  </mat-card>

  <mat-card>
    <mat-card-title>
      Start Here Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <div class="p-b-8 flex flex-col gap-2">
        <span *ngIf="!license.isRenewal">Thank you for your interest in applying for a psilocybin worker
          permit through the Oregon Psilocybin Services -
          Training Program, Licensing, and Compliance system (TLC). </span>

        <span *ngIf="license.isRenewal">Thank you for your interest in applying to renew your psilocybin worker
          permit through the Oregon Psilocybin Services -
          Training Program, Licensing, and Compliance system (TLC). </span>

        <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
          <div class="flex flex-col gap-2 w-[40%]">
            <strong>Psilocybin Worker Permit Requirements:</strong>
            <ul>
              <li>Must be 21 years of age or older
              </li>
              <li>Must pass a criminal background check
              </li>
              <li>Must pay a worker permit fee
              </li>
            </ul>
          </div>

          <div class="flex flex-col gap-2">
            <strong>Who must have a valid psilocybin worker permit?</strong>
            <div class="p-l-24">
              An individual who is a licensee or a licensee representative must have a valid worker permit if the
              individual participates in:
            </div>

            <div style="padding-left: 1em" class="flex flex-col gap-3">
              <ul>
                <li>The provision of psilocybin services at a licensed premises.
                </li>
                <li>The possession, manufacturing, securing or selling of psilocybin products at a
                  licensed premises.
                </li>
                <li>The recording of the possession, manufacturing, securing or selling of psilocybin
                  products at a licensed premises.
                </li>
                <li>The verification of any document described in ORS 475A.445.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="flex flex-row">
          <div style="padding-top: 2em" class="flex flex-col gap-2">
            <strong>The completed application packet contains the following:</strong>

            <ul>
              <li>Completed and signed worker permit application
              </li>
              <li>Uploaded copy of the front and back of a valid, unexpired government-issued photo
                identification for the applicant
              </li>
            </ul>
          </div>


        </div>

        <br>
        <h4 *ngIf="license.isRenewal">Timely and Untimely Applications:</h4>

        <div style="padding-top: 2em" *ngIf="license.isRenewal" class="flex flex-row">

             <ul>
            <li>
              <strong>Timely: </strong>&nbsp;&nbsp;&nbsp;Renewal applications that are complete, submitted according to requirements,
              and submitted at least 60 days before the permit expires will be considered timely under OPS rules.
              Applicants who submit timely applications may continue to operate on an expired permit if OPS is unable
              to process the renewal application prior to the permit expiration date. Incomplete renewal applications
              will not be considered timely unless they are made complete <strong>at least 60 days</strong>&nbsp;&nbsp;&nbsp; before the permit expires.
            </li>
            <li>
              <strong>Untimely: </strong>&nbsp;&nbsp;&nbsp;Renewal applications that are submitted <strong>less than 60 days</strong>&nbsp;&nbsp;&nbsp; before the permit
              expires will be considered untimely under OPS rules. Applicants who submit untimely applications are prohibited
              from continuing to operate on an expired permit if OPS is unable to process the renewal application prior to the
              permit expiration date. Applicants are prohibited from exercising permit privileges on the date their permit expires
              if OPS is unable to process their renewal application before the expiration date and the renewal application is untimely.
            </li>
            </ul>
          </div>

        <div style="padding-top: 2em" class="flex flex-row">
          <div class="flex flex-col gap-2">
            <strong>Important Notes: </strong>
            <ul>
              <li>Please review each section of the application to ensure it is complete
              </li>
              <li>A fee page will describe when and how to submit the worker permit fee which may be paid
                online, by mail, or in-person
              </li>
              <li *ngIf="!license.isRenewal">
                <strong>Incomplete and Insufficient Application Statuses:</strong>
              </li>
            </ul>

            <div style="padding-left: 1em;" *ngIf="!license.isRenewal" class="flex flex-col gap-2">
              <ul>
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">Incomplete: An application is considered incomplete if the application is missing
                  required information (e.g., the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your
                  application complete. You have 30 days from the initial date you are notified to complete your
                  application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="showNewIncompleteDates(license.applicationDate)">Insufficient: An application is considered insufficient if the complete application
                  or site inspection does not meet requirements outlined in statute or rule. If the application is
                  insufficient,
                  we will notify you by email to give you an opportunity to meet requirements. You will have 30 days from
                  the initial date you are notified to meet requirements, or your application will be denied.
                </li>

                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">Incomplete: An application is considered incomplete if the application is missing
                  required information (e.g., the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your
                  application complete. You have 90 days from the initial date you are notified to complete your
                  application. If you fail to do so, the application will be closed.
                </li>
                <li *ngIf="!showNewIncompleteDates(license.applicationDate)">Insufficient: An application is considered insufficient if the complete application
                  or site inspection does not meet requirements outlined in statute or rule. If the application is
                  insufficient,
                  we will notify you by email to give you an opportunity to meet requirements. You will have 90 days from
                  the initial date you are notified to meet requirements, or your application will be denied.
                </li>
              </ul>
            </div>

          </div>
        </div>


        <div style="padding-top: 2em" class="flex flex-col gap-2">
          <span *ngIf="!license.isRenewal">
            <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin
              worker permit application. </span>
              <div>The application automatically saves in TLC. You may exit the
            application and come back later to complete and submit the application, if needed.</div>
          </span>
          <span class="strong" *ngIf="license.isRenewal">
            <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin
              worker permit renewal application. </span>
              <div>The application automatically saves in TLC. You may exit the
            application and come back later to complete and submit the renewal application, if needed.</div>
          </span>
        </div>
        <div style="padding-top: 2em;" class="flex flex-col gap-2">
          <span>
            <span class="strong">DISCLAIMER:</span>&nbsp;&nbsp;&nbsp;&nbsp; Psilocybin remains a schedule I drug under the federal Controlled Substances
            Act. Applicants are responsible for
            making their own determinations regarding the legal risks associated with participating in this program. The
            information you provide in your application
            materials, including applicant name, is subject to disclosure under Oregon's public records laws.
          </span>
        </div>

      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Applicant Information Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">

      <div *ngFor="let applicant of license.applicants" class="p-b-16">
      <div><strong>Applicant Information</strong></div>
      <h3><i><u>{{applicant.legalFirstName}} {{applicant.legalLastName}}</u></i></h3>

      <div class="flex flex-col">
        <span><strong>Legal Name</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>First</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.legalFirstName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Last</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.legalLastName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Middle</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.legalMiddleName}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Preferred Name</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>First</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.preferredFirstName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Last</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.preferredLastName}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Middle</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.preferredMiddleName}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <span><strong>Prior names and aliases</strong></span>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>This information is used for the purposes of the background check</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.alternateNames}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Date of Birth</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.dob | date}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col mt-4">
        <span><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></span>
        <ul>
          <li>
            As part of your application for an initial or renewal license, Federal and State laws require you to provide your Social Security
            Number (SSN), if you have one, to Oregon Psilocybin Services for child support enforcement purposes (42 USC § 666(a)(13) & ORS
            25.785). If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon Psilocybin
            Services may refuse to process your application. Your SSN will be used only for child support enforcement purposes unless you confirm your
            agreement that OPS can use it for administrative purposes as well.
          </li>
        </ul>
        <div>
          <span class="strong">IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by Oregon Psilocybin Services. </span>
        </div>
        <ul>
          <li>
            Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use
            your SSN for the following administrative purposes only: to positively confirm your identity
            during the criminal records check. Oregon
            Psilocybin Services will not deny you any rights, benefits or privileges otherwise provided by law
            if you do not consent to use of your SSN for these administrative purposes (5 USC§ 552(a)).
            <span class="strong">Please check the appropriate box next to the social security field indicating whether you
              consent or <br>do not consent.</span>
          </li>
        </ul>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>SSN</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.ssn}}</span>
            </div>
            <span class="flex flex-row">
              <span class="k-icon"  [ngClass]="applicant.noSSN ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I don't have a social security number</span>
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Do you consent to use of SSN for purposes of confirming identity during a criminal records check?</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.ssnAttestation ? 'Yes' : 'No'}}</span>
            </div>
          </div>
        </div>
      </div>

      <h3>Contact Information</h3>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Primary Phone</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.phone}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Alternate Phone</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.alternatePhone}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Primary Email Address</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.email}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>Confirm Email Address</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.email}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Preferred Language</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.language}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Other OPS Licenses or Permits</strong></span>
            <div class="flex flex-row gap-2">
              <span class="flex flex-row">
                <span class="k-icon"  [ngClass]="applicant.previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.previousLicense">
          <div class="flex flex-col gap-2">
            <span><strong>Please provide the license id(s) for each Oregon Psilocybin Services license.</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{applicant.affiliatedLicenses}}</span>
            </div>
          </div>
        </div>
      </div>

      <h3>Address</h3>
      <span>Physical Address</span>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Street Apt/Unit/Suite</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.physicalStreet}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>City</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.physicalCity}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="strong">State/US territory/freely associated state</span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.physicalState}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-6">
          <div class="flex flex-col gap-2">
            <span><strong>Zip</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.physicalZip}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>County</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.physicalCounty}}</span>
            </div>
          </div>
        </div>
      </div>

      <span>Mailing Address </span>
      <div class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-3">
          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-2">
              <span class="flex flex-row">
                <span class="k-icon"  [ngClass]="applicant.mailingIsPhysical ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">Same as Physical</span>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!applicant.mailingIsPhysical" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-6">
          <div class="flex flex-col gap-2">
            <span><strong>Street Apt/Unit/Suite</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.mailingStreet}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>City</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.mailingCity}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span class="strong">State/US territory/freely associated state</span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.mailingState}}</span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!applicant.mailingIsPhysical" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Zip</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.mailingZip}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>County</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{applicant.mailingCounty}}</span>
            </div>
          </div>
        </div>
      </div>

      <br>

      <div class="flex flex-col">
        <div class="m-t-8 flex flex-row">
          <div class="flex flex-col gap-3">
            <span><strong>Residential history outside of Oregon in the past 5 years</strong></span>
            <span>*This information is used for the purposes of the background check.</span>
            <span>*City, state, country, from month/year to month/year.</span>
            <div class="flex flex-row" *ngFor="let residence of applicant.residentialHistory">
              <div class="flex flex-row gap-1">
                <span>{{residence.city}}</span>
                <span>{{residence.state}},</span>
                <span>{{residence.country}}</span>
                <span class="m-l-8"><strong>From:</strong></span>
                <span>{{residence.from | date: 'MMM, yyyy'}}</span>
                <span class="m-l-8"><strong>To:</strong></span>
                <span>{{residence.to | date: 'MMM, yyyy'}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>

      <div *ngIf="license.isRenewal" class="flex flex-col">
        <div class="flex flex-row">
          <div class="flex flex-col gap-2">
            <span class="flex flex-row">
              <span class="k-icon"  [ngClass]="applicant.applicantPageCorrect ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my
              application or revocation of my license.</span>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="license.isRenewal" class="flex flex-col">
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Please list any information on this page that is outdated or incorrect, but you are unable to change</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{applicant.applicantPageCorrectReason}}</span>
            </div>
            <div class="text-wrap">You are required to submit a Change Request to update the information you listed above. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</div>
          </div>
        </div>
      </div>

      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Documents Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <div><strong>Identity Verification</strong></div>
      <div>You must upload a copy of the <strong>&nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; of a valid, unexpired government-issued
            photo identification. Accepted identification includes:</div>
      <ul>
        <li>Passport;</li>
        <li>Driver license, whether issued by the State of Oregon or by another state of the United States - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>Identification card issued under ORS 807.400 - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>United States military identification card - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;;</li>
        <li>An identification card issued by a federally recognized Indian tribe with photo, name and date of birth - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;; or</li>
        <li>Any other identification card issued by a state or territory that bears a picture of the person, the name of the person, the person's date of birth and a physical description of the person - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;&nbsp;</li>
      </ul>

      <br>

      <div>
      <h4>Current Documents</h4>
      <div>
        <div class="flex flex-row w-full">
          <span class="flex flex-col strong w-[40%]">File</span>
          <span class="flex flex-col strong w-[60%]">Requirement</span>
        </div>
        <div *ngFor="let applicant of license.applicants">
          <div *ngFor="let document of applicant.applicantDocuments" class="flex flex-row">
          <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
          <span class="flex flex-col w-[60%]">
            <span *ngFor="let type of document.types">
              <span *ngFor="let docType of documentTypes">
                <span *ngIf="docType.id == type"> {{docType.type}} </span>
              </span>
            </span>
          </span>
          </div>
        </div>

      </div>
    </div>
        <br>

      <div *ngIf="license.isRenewal" class="flex flex-row">
        <div class="flex flex-col gap-2">
          <span class="flex flex-row">
            <span class="k-icon"  [ngClass]="license.documentPageCorrect ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap">I certify the information provided is true and complete to the best of my knowledge. I understand falsifying an application, supplying misleading information,
              or withholding information is grounds for denial of my application or revocation of my license.</span>
          </span>
        </div>
      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Fee Information Page
    </mat-card-title>
    <mat-card-content>

      <div class="flex flex-col gap-2">
        <span>
          <span *ngIf="!license.isRenewal">Non-Refundable Worker Permit Fee $25.00</span>
          <span *ngIf="license.isRenewal">Non-Refundable Worker Permit Renewal Fee $25.00</span>
        </span>

        <span *ngIf="!license.isRenewal">
          After the worker permit application has been approved, pending worker permit fee payment and clearance,
          you will receive a request to pay the worker permit fee. At that time, we will provide a permit fee remittance
          form to submit with your permit fee payment. A worker permit will not be issued until the worker permit fee is
          paid and cleared. If issued a worker permit, an individual may not perform the duties described in ORS 475A.445
          until the effective date of approval.
        </span>
        <span *ngIf="license.isRenewal">
          After the worker permit renewal application has been approved, pending worker permit fee payment and clearance,
          you will receive a request to pay the worker permit renewal fee. At that time, we will provide a permit fee remittance
          form to submit with your permit renewal fee payment. A worker permit will not be renewed until the fee is
          paid and cleared. An individual may not perform the duties described in ORS 475A.445 without an approved worker permit.
        </span>
        <span *ngIf="license.isRenewal">
          Please Note: If payment is not submitted within 30 days from the date that you received notice that your renewal application has been moved to "renewal approved pending payment and clearance" status, your renewal application will be closed due to non-payment.
        </span>
        <div *ngIf="license.isRenewal" class="flex flex-col gap-4">
          <span>Payment method options:</span>
          <ul>
            <li>Online</li>
            <li>Money Order</li>
            <li>Cashier's Check</li>
            <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
            <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
          </ul>

          <div *ngIf="license.isRenewal" class="flex flex-row justify-center items-start">
            <span><strong>Instructions for Submitting the Fee Payment by Mail or In-Person</strong></span>
          </div>

          <span *ngIf="license.isRenewal">
            Money orders and checks are payable to: <strong>Oregon Psilocybin Services</strong>
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Renewal applications will be reviewed
            once payment has been cleared. Renewal application fees are non-refundable.
          </span>

          <div class="flex flex-col">
            <span>
              <strong *ngIf="license.isRenewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>
            </span>
            <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
            <span>RE: OPS</span>
            <span>PO Box 14260</span>
            <span>Portland, OR 97293-0260</span>
          </div>

          <div class="flex flex-col">
            <span><strong>In-person payment with a money order or check:</strong></span>
            <span>
              To make an in-person fee payment with a money order or check, print the remittance form and proceed to Cashier's Office on the second floor of the Portland State Office
              Building at 800 NE Oregon St, Suite 200, Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
            </span>
          </div>

          <span>
            Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
            If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services at the Cashier's Office
            window which does not require an appointment. Please include the remittance form with the payment.
          </span>

          <div class="flex flex-col">
            <span><strong>To make cash payment arrangements or for payment questions, please contact:</strong></span>
            <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">
              <a href="mailto:licensing.psilocybin@oha.oregon.gov ">
                <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                  <span>
                    licensing.psilocybin&#64;oha.oregon.gov </span>
                  <mat-icon>email</mat-icon>
                </div>
              </a>
              <span>or Licensing Inquiries: 1-971-673-0304</span>
            </div>
          </div>
        </div>

        <span style="color:red" class="strong">
          <span *ngIf="!license.isRenewal">
            Do not send the permit fee payment until contacted by OPS that your application has been approved and you
            receive payment instructions.
          </span>
          <span *ngIf="license.isRenewal">
            Do not send the permit renewal fee payment until contacted by OPS that your application has been approved and you
            receive payment instructions.
          </span>
        </span>

        <div class="flex flex-col" *ngIf="!license.isRenewal">
          <span><strong>If you have any questions, please send us a TLC message or email/call: </strong></span>
          <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">

              <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                <span>
                  licensing.psilocybin&#64;oha.oregon.gov </span>
                <mat-icon>email</mat-icon>
              </div>

            <span>or (971) 673-0304</span>
          </div>
        </div>
      </div>
    </mat-card-content>

    <div class="page-break"></div>

    <mat-card-title>
      Review and Submit Page
    </mat-card-title>
    <mat-card-content class="flex flex-col gap-4">
      <div><strong>Review Your Application</strong></div>

         <div><strong>Name and Address</strong></div>
         <div>
            <div class="flex flex-col gap-2">
              <div class="flex flex-col lg:flex-row gap-2">
                <span class="strong">Name:</span>
                <span>{{license.applicants[0].legalFirstName}} {{license.applicants[0].legalMiddleName}} {{license.applicants[0].legalLastName}}</span>
                <span></span>
                <span></span>
              </div>
              <div class="flex flex-col lg:flex-row gap-2">
                <span class="w-[20%]"><strong>Physical Address</strong></span>
                <div class="flex flex-row gap-1">
                  <span>{{license.applicants[0].physicalStreet}}</span>&nbsp;
                  <span>{{license.applicants[0].physicalCity}},</span>&nbsp;
                  <span>{{license.applicants[0].physicalState}}</span>
                </div>
                <div class="flex flex-row gap-1">
                  <span>{{license.applicants[0].physicalZip}}</span>&nbsp;
                  <span>{{license.applicants[0].physicalCounty}}</span>&nbsp;
                  <span *ngIf="license.applicants[0].physicalCounty">County</span>
                </div>
              </div>
              <div *ngIf="!license.applicants[0].mailingIsPhysical" class="flex flex-col lg:flex-row gap-2">
                <span class="w-[20%]"><strong>Mailing Address</strong></span>
                <div class="flex flex-row gap-1">
                  <span>{{license.applicants[0].physicalStreet}}</span>&nbsp;
                  <span>{{license.applicants[0].physicalCity}},</span>&nbsp;
                  <span>{{license.applicants[0].physicalState}}</span>
                </div>
                <div class="flex flex-row gap-1">
                  <span>{{license.applicants[0].physicalZip}}</span>&nbsp;
                  <span>{{license.applicants[0].physicalCounty}}</span>&nbsp;
                  <span *ngIf="license.applicants[0].physicalCounty">County</span>
                </div>
              </div>
              <div *ngIf="license.applicants[0].mailingIsPhysical" class="flex flex-col lg:flex-row gap-2">
                <span class="w-[20%]"><strong>Mailing Address</strong></span>
                <span>Same As Physical</span>
              </div>
              <div class="flex flex-col lg:flex-row gap-2">
                <span class="w-[20%]"><strong>DOB:</strong></span>
                <span>{{license.applicants[0].dob | date}}</span>
              </div>
              <div class="flex flex-col lg:flex-row gap-2">
                <span class="w-[20%]"><strong>Contact Information</strong></span>
                <div class="flex flex-col">
                  <div class="flex flex-row gap-2">
                    <span>Email:</span>
                    <span>{{license.applicants[0].email}}</span>
                  </div>
                  <div class="flex flex-row gap-2">
                    <span>Phone:</span>
                    <span>{{license.applicants[0].phone | mask: '(000) 000-0000 000000'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <br>
      <div><strong>Documents</strong></div>
      <div>
        <div class="flex flex-row w-full">
          <span class="flex flex-col strong w-[40%]">File</span>
          <span class="flex flex-col strong w-[60%]">Requirement</span>
        </div>
        <div *ngFor="let applicant of license.applicants">
          <div *ngFor="let document of applicant.applicantDocuments" class="flex flex-row">
          <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
          <span class="flex flex-col w-[60%]">
            <span *ngFor="let type of document.types">
              <span *ngFor="let docType of documentTypes">
                <span *ngIf="docType.id == type"> {{docType.type}} </span>
              </span>
            </span>
          </span>
          </div>
        </div>

      </div>

      <br><br>
      <div><strong>Signature and Acknowledgements</strong></div>
      <div class="flex flex-col gap-2">
        <ul>
          <li>I certify the information provided in this application is true and complete to
            the best of my knowledge.
            I understand falsifying an application, supplying misleading information, or withholding information
            is grounds for denial of my
            application or revocation of my permit.
          </li>
          <li>I understand I am responsible for making my own determination regarding the legal
            risks associated with a
            Schedule 1 substance under the Federal Controlled Substances Act.
          </li>
          <li>
            I understand the information provided in application materials, including applicant name, is subject to disclosure
            under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
          </li>
          <li>I understand the following information in the application will be used by Oregon
            Psilocybin Services to start the background
            check process: legal name; date of birth; physical address; phone number; email address; proof of
            identity; prior addresses if lived out of state during the past five years; social
            security number (if consented); and prior names and aliases.
          </li>
          <li>I understand I must complete and pass a background check as a condition of being
            granted a worker permit.
          </li>
          <li>I understand I must notify Oregon Psilocybin Services in writing within 10
            business days of any conviction for any misdemeanor
            or felony committed and I will be required to undergo another criminal background check.
          </li>
          <li>I understand I must notify Oregon Psilocybin Services in writing within 10
            business days of a change in contact information.
          </li>
          <li>I have read, understand, and agree to adhere to the Oregon Psilocybin Services
            Revised Statutes (ORS) Chapter 475A, Oregon
            Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or
            laws.
          </li>
          <li>I understand that failure to adhere to these statutes and rules may result in
            denial of my application or disciplinary
            action against any future permits issued by Oregon Psilocybin Services.
          </li>
          <li>I understand the psilocybin worker permit has a term of one year from the
            effective date of approval. If I wish to
            renew my worker permit after that term, l must complete a renewal application.
          </li>
          <li>I understand a worker permit will not be issued until the worker permit fee has
            been paid and has cleared. I understand
            that I may not perform the duties described in ORS 475A.445until the effective date of approval.
          </li>
          <li>I understand the worker permit fee is non-refundable.
          </li>
        </ul>

        <span class="flex flex-row">
          <span class="k-icon"  [ngClass]="license.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
          <span class="text-wrap">I have read and I understand the above statements</span>
        </span>
        <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
          <span>Name or Initials: {{license.electronicSignature}}</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
